/**
 * @generated SignedSource<<51c92169f7664135236c80ab21f54450>>
 * @relayHash 9bac9c6051f91474eab6ad0b3fe437de
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6ab556cd684caf2712069ec6e29d1861b7457d4c71e891cf049ae383c364a378

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ConfluenceTrackType = "BRIEFING" | "NARRATION" | "%future added value";
export type PlaylistQuery$variables = {
  cloudId: string;
};
export type PlaylistQuery$data = {
  readonly confluence_getPlaylist: {
    readonly tracks: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly mainContent: {
          readonly history: {
            readonly createdBy: {
              readonly displayName: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly id: string | null | undefined;
          readonly space: {
            readonly key: string | null | undefined;
          } | null | undefined;
          readonly title: string | null | undefined;
          readonly type: string | null | undefined;
        } | null | undefined;
        readonly type: ConfluenceTrackType;
      }>;
    };
  } | null | undefined;
};
export type PlaylistQuery = {
  response: PlaylistQuery$data;
  variables: PlaylistQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "kind": "ScalarField",
  "name": "key"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PlaylistQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConfluencePlaylist",
        "kind": "LinkedField",
        "name": "confluence_getPlaylist",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluencePaginatedTracks",
            "kind": "LinkedField",
            "name": "tracks",
            "plural": false,
            "selections": [
              {
                "concreteType": "ConfluenceTrack",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "mainContent",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v4/*: any*/),
                      (v3/*: any*/),
                      {
                        "concreteType": "Space",
                        "kind": "LinkedField",
                        "name": "space",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "History",
                        "kind": "LinkedField",
                        "name": "history",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "__typename"
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "6ab556cd684caf2712069ec6e29d1861b7457d4c71e891cf049ae383c364a378",
    "metadata": {},
    "name": "PlaylistQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "dfe468e41eff900c206fb9ed2fd1aada";

export default node;
